export const CategoryTypes = [
    { Caption: "I'm a trade agent and I would like to work with you", Id: 1 },
    { Caption: "I'm an hotelier or hotel chain", Id: 2 },
    { Caption: 'General enquiries', Id: 3 },
    { Caption: 'Booking enquiries', Id: 4 },
    { Caption: 'Payment queries', Id: 5 },
    { Caption: 'Complaint', Id: 6 },
];
